import React, { useState } from "react";
import {
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import { dynamicImage } from "../../../../../../Utils";
import { Image, P } from "../../../../../../AbstractElements";
import {
  getAPIURL,
  getAPIURLAWS,
  getSmartUser,
  getUserID,
} from "../../../../../../services/helper";
import http from "../../../../../../services/http";
import { toast } from "react-toastify";
import {
  newGroupAdded,
  UpdateBlocked,
  UpdateFriends,
  UpdateRequests,
} from "../../../../../../ReduxToolkit/Reducers/ChatReducer";
import axios from "axios";
import Swal from "sweetalert2";

const api_url_aws = getAPIURLAWS();
const current_user_id = getUserID();

export default function AddNewFriendModal({ isOpen, toggle }) {
  const { members } = useSelector((state) => state.chat);
  const [searchTerm, setSearchTerm] = useState("");
  const dispatch = useDispatch();

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const filteredMembers = members.filter((member) =>
    member.name.toLowerCase().includes(searchTerm.toLowerCase())
  );
  const api_url = getAPIURL();
  const handleRequestSend = async (friends_id) => {
    try {
      const data = {
        user_id: getUserID(),
        friends_id,
      };
      const resp = await axios.post(`${api_url}/friends/requests`, data);
      const { friends_list, pending_requests, block_list } = resp;
      if (resp.success) {
        toast.success("Friend Request Sent");
        dispatch(UpdateFriends(friends_list));
        dispatch(UpdateRequests(pending_requests));
        dispatch(UpdateBlocked(block_list));
      } else {
        toast.error(resp.success.message);
      }
    } catch (e) {
      console.error("Error while sending request", e);
      toggle();
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      centered
      size="lg"
      className="justify-center"
    >
      <ModalHeader toggle={toggle}>Add New Friend</ModalHeader>
      <ModalBody>
        <Input
          type="text"
          placeholder="Search members..."
          value={searchTerm}
          onChange={handleSearchChange}
          className="mb-3"
        />
        <div className="members-grid">
          {filteredMembers.map((member) => (
            <div key={member.id} className={`member-item`}>
              <Image
                className="img-fluid rounded-circle member-image"
                src={member.src ? member.src : dynamicImage("avtar/3.jpg")}
                alt="user"
              />
              <span className="member-name">{member.name}</span>
              <Button
                className="ml-auto"
                color="primary"
                onClick={() => handleRequestSend(member.id)}
              >
                Send Request
              </Button>{" "}
            </div>
          ))}
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color="danger" onClick={toggle}>
          Cancel
        </Button>
      </ModalFooter>
      <style jsx>{`
        .group-name-container {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        .group-name-input {
          flex: 1;
          margin-right: 10px;
        }
        .members-grid {
          display: flex;
          flex-direction: column;
          flex-wrap: wrap;
          gap: 10px;
          justify-content: center;
        }
        .member-item {
          display: flex;
          flex-direction: row;
          align-items: center;
          padding: 10px;
          cursor: pointer;
          background-color: white;
          border-radius: 8px;
          border: 1px solid #ccc;
          width: 350px;
        }
        .member-item.selected-member {
          background-color: #28a745;
          border-color: #28a745;
        }
        .member-image {
          width: 40px;
          height: 40px;
          margin-right: 8px;
        }
        .member-name {
          margin-top: 5px;
          font-weight: 500;
          text-align: center;
        }
      `}</style>
    </Modal>
  );
}
